import { Injectable } from '@angular/core';
import { IControlSettingTemplatesSearchCriteria } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class ControlSettingTemplatesService {
    public static $name: string = 'controlSettingTemplatesService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getControlSettingTemplate(hardwareItemId : number, id: string):
        angular.IPromise<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel> {
        return this.proxyService.request({
            endPoint: 'controlSettingTemplates',
            routeParams: {
                'hardwareItemId': hardwareItemId,
                'id': id
            },
            route: 'getControlSettingTemplate'
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel>();
    }

    public saveTemplate(hardwareItemId: number, item: CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel): angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'controlSettingTemplates',
            route: 'saveControlSettingTemplate',
            routeParams: {
                'hardwareItemId': hardwareItemId
            },
            data: item
        }).as<void>();
    }

    public deleteTemplate(hardwareItemId: number,id: string):
        angular.IPromise<void> {
        return this.proxyService.request({
            endPoint: 'controlSettingTemplates',
            routeParams: {
                'hardwareItemId': hardwareItemId,
                'id': id
            },
            route: 'deleteControlSettingTemplate'
        }).as<void>();
    }


    public getControlSettingTemplatesList(query: IControlSettingTemplatesSearchCriteria):
        angular.IPromise<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesListViewModel> {
        const order = query.order[0] === query.order[0].toUpperCase() ? query.order : query.order[0].toUpperCase() + query.order.substr(1);
        const sort = (query.ascending) ? 0 : 1;
        return this.proxyService.request({
            endPoint: 'controlSettingTemplates',
            queryParams: {
                'searchCriteria.hardwareCategory': query.hardwareCategory,
                'searchCriteria.locationId': query.locationId,
                'searchCriteria.moduleId': query.moduleId,
                'searchCriteria.deviceId': query.deviceId,
                'searchCriteria.templateType': query.templateType,
                'searchCriteria.pagingCriteria.includeTotalCount': query.includeTotalCount,
                'searchCriteria.pagingCriteria.skip': (query.page - 1) * query.limit,
                'searchCriteria.pagingCriteria.sortDirection': sort,
                'searchCriteria.pagingCriteria.sortExpressions': order,
                'searchCriteria.pagingCriteria.take': query.limit,
                'searchCriteria.wildcard': query.wildcard
            },
            route: 'getControlSettingTemplatesList'
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesListViewModel>();
    }

}
